import { createAsyncThunk } from '@reduxjs/toolkit';
import * as composeApi from '../../api/compose';

export const getPatientsList = createAsyncThunk('getPatientsList', async (data) => {
    const res = await composeApi.getPatientsList({ data: data });
    return res.data;
});



export const getTemplateList = createAsyncThunk('getTemplateList', async (data) => {
    const res = await composeApi.getTemplateList({ data: data });
    return res.data;
});


export const AddNewCompose = createAsyncThunk('AddNewCompose', async (data) => {
    const res = await composeApi.AddNewCompose({ data: data });
    return res.data;
});

export const getLocation = createAsyncThunk('getLocation', async (data) => {
    const res = await composeApi.getLocation({ data: data });
    return res.data;
});

export const getPeopleByLocationId = createAsyncThunk('getPeopleByLocationId', async (data) => {
    const res = await composeApi.getPeopleByLocationId({ data: data });
    return res.data;
});

export const getAllLocationOneTimeGroup = createAsyncThunk('getAllLocationOneTimeGroup', async (data) => {
    const res = await composeApi.getAllLocationOneTimeGroup({ data: data });
    return res.data;
});